import React, { forwardRef, useContext, useRef } from 'react';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import Pages from '../../../../../config/Pages';
import InputDropDown from '../../../../../core/components/inputs/inputDropDown/InputDropDown';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import styles from './Vinculos.module.scss';
import { Button } from 'primereact/button';
import { inputsVinculos } from '../../PageInputs';
import ModalPesquisar from '../modalPesquisar/ModalPesquisar';
import { MultipageContext } from '../../../../../core/components/Multipage';
import { isEmpty } from '../../../../../core/utils/ValidForm';
import PageMessages from '../../../../../config/translations/PageMessages';
import FieldWithInfo from '../FieldWithInfo';
import { assignRefs, printToast } from '../../../../../core/utils/Global';
import SimpleTable from '../../../../../core/components/simpleTables/SimpleTable';
import ButtonSeplag from '../../../../../components/buttonSeplag/ButtonSeplag';
import instrumentoService from '../../../../../service/InstrumentoService';
import exercicioIntegracaoService from '../../../../../service/integracao/ExercicioIntegracaoService';
import vinculoPropostaService from '../../../../../service/VinculoPropostaService';
import Shareds from '../../../../../config/translations/Shareds';
import { Column } from 'primereact/column';
import stylesDiff from '../Utils.module.scss';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';

function Vinculos({ isView, dadosIndicadorRef }, ref) {
    const tableRef = useRef(null);
    const formRef = useRef(null);
    const modalPesquisarRef = useRef(null);
    const { confirmOkRef, idIndicador } = useContext(MultipageContext);

    const generateLocalId = ({ codigo, exercicio, instrumento, nome }) =>
        `${codigo}-${exercicio?.ano}-${instrumento?.descInstrumento}-${nome}`;

    const Inputs = ({ formik, formController }) => (
        <form onSubmit={formik.handleSubmit} className={`p-col-12 p-grid p-fluid ${styles.form}`}>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="instrumento"
                cols="12 2"
            >
                <InputDropDown
                    valueIsCompleteObject
                    formik={formik}
                    optionLabel="descInstrumento"
                    callbackSetList={instrumentoService.list.bind(instrumentoService)}
                />
            </FieldWithInfo>
            <div className={styles.buttonIncluir}>
                <Button
                    icon="pi pi-search-plus"
                    className="p-button-outlined"
                    type="button"
                    tooltip="Pesquisar"
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => {
                        if (isEmpty(formik.values.instrumento)) {
                            confirmOkRef.current?.show(
                                PageMessages.sei.propostaIndicador.instrumentoEmpty
                            );
                        } else {
                            modalPesquisarRef.current.show({
                                instrumento: formik.values.instrumento,
                            });
                        }
                    }}
                />
            </div>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="exercicio"
                cols="12 2"
            >
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    optionValue="idenExercicio"
                    optionLabel="ano"
                    filter
                    callbackSetList={exercicioIntegracaoService.list.bind(
                        exercicioIntegracaoService
                    )}
                />
            </FieldWithInfo>
            <FieldWithInfo formController={formController} formik={formik} id="codigo" cols="12 2">
                <InputText
                    keyfilter="int"
                    value={formik.values.codigo}
                    onChange={formik.handleChange}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descricao"
                className={styles.withLengthCounter}
                cols="12 3"
            >
                <InputTextLengthCounter maxLen={200}>
                    <InputText
                        name="descricao"
                        value={formik.values.descricao}
                        onChange={formik.handleChange}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <div className={`${styles.buttonIncluir} ${styles.paddingLeft}`}>
                <Button
                    icon="pi pi-arrow-circle-down"
                    type="submit"
                    label="Incluir"
                    onClick={() => formController.addCountClick()}
                />
            </div>
        </form>
    );

    return (
        <>
            <ModalPesquisar
                ref={modalPesquisarRef}
                onHide={({ nome, ...rest }) => {
                    if (!isEmpty(nome)) {
                        tableRef.current?.setLista([
                            {
                                ...rest,
                                descricao: nome,
                                exercicioView: rest?.exercicio?.ano,
                                instrumentoView: rest?.instrumento?.descInstrumento,
                                localId: generateLocalId({ ...rest, nome }),
                            },
                            ...(tableRef.current?.lista ?? []),
                        ]);
                    }
                }}
            />
            <Fieldset legend="Vínculos" className={styles.container}>
                {!isView && (
                    <BaseForm
                        ref={formRef}
                        redirectOnSave={false}
                        buscarOnLoad={false}
                        onSubmit={async ({ registro, formController }) => {
                            const { exercicio, ...rest } = registro;
                            tableRef.current?.setLista([
                                {
                                    ...rest,
                                    exercicio,
                                    exercicioView: exercicio?.ano,
                                    instrumentoView: rest?.instrumento?.descInstrumento,
                                    localId: `${rest?.codigo}-${exercicio?.ano}-${rest?.instrumento?.descInstrumento}-${rest?.descricao}`,
                                },
                                ...(tableRef.current?.lista ?? []),
                            ]);
                            formController.setCountClick(0);
                            formRef.current?.formik.setValues(
                                formRef.current.formController.initialValues
                            );
                        }}
                        showToast={false}
                        page={Pages.sei.propostaIndicador}
                        initialValues={inputsVinculos.filter((input) => input?.form?.use ?? false)}
                    >
                        <Inputs />
                    </BaseForm>
                )}
                <SimpleTable
                    ref={assignRefs(ref, tableRef)}
                    rowClassName={({ localId, ...rest }) => {
                        const ids = dadosIndicadorRef?.current?.vinculoIndicadores.map((el) =>
                            generateLocalId({ ...el, nome: el?.descVinculo })
                        );
                        if (isEmpty(localId) && idIndicador) {
                            const id = generateLocalId({ ...rest, nome: rest?.descricao });

                            return !ids.includes(id) ? stylesDiff.tableDiff : '';
                        }
                        return !isEmpty(localId) && idIndicador ? stylesDiff.tableDiff : '';
                    }}
                >
                    {inputsVinculos
                        .filter((input) => input?.table?.use ?? false)
                        .map((input, index) => (
                            <Column key={index} field={input.name} header={input.label} />
                        ))}
                    {!isView && (
                        <Column
                            header={'Excluir'}
                            body={(data) => (
                                <ButtonSeplag
                                    tipo="danger"
                                    type="button"
                                    tooltip="Excluir"
                                    tooltipOptions={{ position: 'top' }}
                                    icon="pi pi-trash"
                                    className="p-button-danger p-mb-1"
                                    theme="Raised"
                                    onClick={async () => {
                                        if (data?.id) {
                                            await vinculoPropostaService.remover(data);
                                            printToast({
                                                severity: 'success',
                                                summary: 'Vínculos',
                                                detail: Shareds.form.successDelete,
                                            });
                                            tableRef.current?.setLista(
                                                tableRef.current?.lista.filter(
                                                    ({ id }) => `${id}` !== `${data?.id}`
                                                ),
                                                true
                                            );
                                        } else {
                                            tableRef.current?.setLista(
                                                tableRef.current?.lista.filter(
                                                    ({ localId }) =>
                                                        `${localId}` !== `${data?.localId}`
                                                )
                                            );
                                        }
                                    }}
                                />
                            )}
                        />
                    )}
                </SimpleTable>
            </Fieldset>
        </>
    );
}

export default forwardRef(Vinculos);
